<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card outlined>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="user.email"
                label="Email"
                prepend-icon="fa-user"
                type="email"
              />

              <v-text-field
                v-model="user.password"
                label="Password"
                prepend-icon="fa-lock"
                type="password"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <router-link v-translate :to="{ name: 'ResetPassword' }">
              Password dimenticata
            </router-link>
            <v-spacer />
            <v-btn v-translate depressed color="primary" @click="login">
              Accedi
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card outlined class="mt-4">
          <v-card-text class="text-center text-caption">
            Questo gestionale è stato realizzato nell'ambito di "Ode
            Virtuosity", finanziato dall'Unione europea – Next Generation EU -
            PNRR Transizione Ecologica Organismi Culturali e Creativi
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
    }
  },
  methods: {
    login() {
      this.$store
        .dispatch("login", this.user)
        .then(() => {
          this.$router.push({ name: "Home" })
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          this.$store.commit("core/setSnack", {
            level: "error",
            msg: this.$gettext("Login non riuscito."),
          })
          // console.log(err)
        })
    },
  },
}
</script>
